import { call, select, all } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'
import getLoginType from 'utils/getLoginType'

function * addUser (loginName, onAdded, onError) {
  try {
    const loginType = getLoginType(loginName)

    if (!loginType) throw new Error()

    yield call(apiAction, 'AddUser', {
      loginType,
      loginName
    })

    onAdded()
  } catch (error) {
    if (error.code === 303) { // NoChange
      onAdded()
    } else {
      onError()
    }
  }
}

export default function * requestAddUsersFromFileToKanBo (action) {
  const { data } = action.payload

  if (!data) return

  const loginNames = data.split(',')

  if (!loginNames || !loginNames.length) return

  const state = yield select()

  sweetalert({
    type: 'info',
    text: state.kanbo.locale.messages['USERS_ADD_FROM_FILE_IN_PROGRESS'],
    showConfirmButton: false,
    allowOutsideClick: false
  }).catch(sweetalert.noop)

  let newlyAddedCount = 0
  const notAdded = []

  yield all(loginNames.map(loginName => call(
    addUser,
    loginName,
    () => { newlyAddedCount++ },
    () => { notAdded.push(loginName) }
  )))

  try {
    let html = ''
    if (newlyAddedCount) {
      html +=
        '<div>' +
        state.kanbo.locale.messages['USERS_ADD_FROM_FILE_ADDED'].replace('{0}', newlyAddedCount) +
        '</div>'
    }
    if (notAdded.length > 0) {
      if (newlyAddedCount) {
        html += '<br/>'
      }
      html +=
        '<div>' +
        state.kanbo.locale.messages['USERS_ADD_FROM_FILE_ERROR'].replace('{0}', notAdded.length) +
        '</div>'
      html += '<div style="max-height: 200px; overflow: auto; text-align: left;">'
      html += '<table class="table table-condensed">'
      html += '<tbody>'
      html += notAdded.map(user => '<tr class="danger"><td>' + user + '</td></tr>').join('')
      html += '</tbody>'
      html += '</table>'
      html += '</div>'
    }

    yield call(sweetalert, {
      type: (newlyAddedCount === 0 && notAdded.length > 0) ? 'error' : 'success',
      html
    })
  } catch (e) {}
}
